import React from 'react';

import { Workspace } from 'src/common/interfaces/workspace.interface';
import { useCurrentOrganization } from 'src/store/organization';

import ManagementDropdownList from './list';
import { useCurrentUser } from 'src/store/user';

interface Props {
  currentWorkspace: Workspace;
  onWorkspaceChanged: () => void;
}

const ManagementDropdownWorkspaceList: React.FC<Props> = ({ currentWorkspace, onWorkspaceChanged }) => {
  const { getMemberWorkspaces, setCurrentWorkspace } = useCurrentOrganization();
  const { currentUser } = useCurrentUser();

  const memberWorkspaces = getMemberWorkspaces(currentUser);

  const onChangeWorkspace = (id: any) => {
    setCurrentWorkspace(memberWorkspaces.find((workspace: Workspace) => workspace.id === id));
    onWorkspaceChanged();
  };

  return (
    <ManagementDropdownList
      selectedValue={currentWorkspace ? currentWorkspace.id : null}
      items={memberWorkspaces}
      defaultItem={{ id: null, name: 'All Workspaces' }}
      onSelectedItemChanged={onChangeWorkspace}
    />
  );
};

export default ManagementDropdownWorkspaceList;
